var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41667 21.8334H17.5833C18.7783 21.8334 19.75 20.8617 19.75 19.6667V7.75008C19.75 7.46276 19.6359 7.18721 19.4327 6.98405C19.2295 6.78089 18.954 6.66675 18.6667 6.66675H15.4167V5.58342C15.4167 2.59666 12.9868 0.166748 10 0.166748C7.01325 0.166748 4.58333 2.59666 4.58333 5.58342V6.66675H1.33333C1.04602 6.66675 0.770465 6.78089 0.567301 6.98405C0.364137 7.18721 0.25 7.46276 0.25 7.75008V19.6667C0.25 20.8617 1.22175 21.8334 2.41667 21.8334ZM6.75 5.58342C6.75 3.79158 8.20817 2.33341 10 2.33341C11.7918 2.33341 13.25 3.79158 13.25 5.58342V6.66675H6.75V5.58342ZM2.41667 8.83342H4.58333V11.0001H6.75V8.83342H13.25V11.0001H15.4167V8.83342H17.5833L17.5855 19.6667H2.41667V8.83342Z",
    fill: "#583F35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopBag);
export default __webpack_public_path__ + "static/media/shopBag.8bc25d97.svg";
export { ForwardRef as ReactComponent };